export type EpisodeSort = "newest" | "score";
export type EpisodeFilter = "all" | "won" | "lost" | "top10";
export type EpisodeFilterOption = {
  readonly key: EpisodeFilter;
  readonly label: string;
};

export type EpisodeLinks = {
  readonly replayHref: string | null;
  readonly episodeHref: string;
};

export type EpisodeTableRow = EpisodeLinks & {
  readonly episodeId: string;
  readonly when: string;
  readonly seats: number;
  readonly mySeatRank: number;
  readonly won: boolean | null;
  readonly topTenPercent: boolean;
  readonly score: number;
  readonly scoreDeltaVsMedian: number;
  readonly maxScore: number;
};

export type LeagueEpisodeTableRow = EpisodeLinks & {
  readonly episodeId: string;
  readonly when: string;
  readonly seats: readonly {
    readonly label: string;
    readonly score: number | null;
  }[];
  readonly topScore: number | null;
};

export type DisplayEpisode = EpisodeTableRow | LeagueEpisodeTableRow;

export function barWidthOf({
  score,
  maxScore,
}: {
  readonly score: number;
  readonly maxScore: number;
}): number {
  if (!(score > 0) || !(maxScore > 0)) return 0;

  // Exponential game scores need a logarithmic share; small scores stay linear.
  const share =
    maxScore >= 100
      ? Math.log2(1 + score) / Math.log2(1 + maxScore)
      : score / maxScore;
  return share * 64;
}
